import Card from "@rio-cloud/rio-uikit/Card";
import { FormattedMessage } from 'react-intl';

import {
  CardsContainer,
} from "@/components/organism/OverviewCards/OverviewCards.styles";

const cardContent = [
  {
    title: 'getStartedPage.overviewCards.poweredByAI.label',
    description: 'getStartedPage.overviewCards.poweredByAI.description',
    iconClass: 'rioglyph-robot',
  },
  {
    title: 'getStartedPage.overviewCards.streamliningFleetManagement.label',
    description: 'getStartedPage.overviewCards.streamliningFleetManagement.description',
    iconClass: 'rioglyph-truck-baseline',
  },
  {
    title: 'getStartedPage.overviewCards.howItHelpsYou.label',
    description: 'getStartedPage.overviewCards.howItHelpsYou.description',
    iconClass: 'rioglyph-stats',
  },
];

const OverviewCards = () => (
  <CardsContainer>
    {cardContent.map((card, index) => (
    <Card
        className='display-grid grid-cols-subgrid grid-rowspan-3 grid-rows-subgrid row-gap-0'
        padding={25}
        shadow='smooth'
        key={index}
    >
      <div className='text-center text-color-darker margin-top-15'>
        <div className='text-size-12'>
          <div className='text-wrap-pretty line-height-125rel text-size-200pct padding-bottom-10 text-capitalize text-medium'>
            <FormattedMessage id={card.title} />
          </div>
        </div>
      </div>
      <div className='text-size-20 text-center padding-15'>
        <span className={`rioglyph ${card.iconClass} text-size-300pct`}/>
      </div>
      <div>
        <p className='margin-bottom-20 text-color-dark'>
          <FormattedMessage id={card.description} />
        </p>
      </div>
    </Card>
    ))}
  </CardsContainer>
);

export default OverviewCards;
